(() => {
  const init = () => {
    document.querySelectorAll('[data-coastal-product]').forEach(root => {
      if (root.dataset.coastalReady) return;
      root.dataset.coastalReady = 'true';
      const quote = root.querySelector('[data-vtx-quote-button]');
      if (!quote) return;
      quote.addEventListener('click', event => {
        const quantity = root.querySelector('input[name="quantity"]');
        if (quantity && !quantity.checkValidity()) {
          event.preventDefault();
          quantity.reportValidity();
          return;
        }
        const selections = [...root.querySelectorAll('[data-vtx-option-current]')].map(node => node.textContent.trim());
        const size = selections[0] || '';
        const pack = selections[1] || '';
        const packSize = Number(pack.match(/\b(1000|500|100)\s*pcs\b/i)?.[1] || 0);
        const count = Number(quantity?.value || 1);
        const amount = packSize ? `${count} pack(s) · ${count * packSize} pcs total` : `${count} pcs`;
        const title = root.querySelector('h1')?.textContent.trim() || '';
        const message = [title, size, pack, amount].filter(Boolean).join(' | ');
        const url = new URL(quote.href, location.origin);
        url.searchParams.set('coastal_quote', message);
        quote.href = url.href;
      });
    });
    const requested = new URL(location.href).searchParams.get('coastal_quote');
    const message = document.querySelector('#ContactForm-body');
    if (requested && message && !message.value.trim()) {
      message.value = requested.slice(0, 400);
      message.dispatchEvent(new Event('input', {bubbles: true}));
    }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once: true});
  else init();
  document.addEventListener('shopify:section:load', init);
})();


